import { render, staticRenderFns } from "./Contractors.vue?vue&type=template&id=f5542c72&scoped=true&"
import script from "./Contractors.vue?vue&type=script&lang=ts&"
export * from "./Contractors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5542c72",
  null
  
)

export default component.exports